// frontend/src/services/playerService.js
import { configuredAxios as api } from './axiosConfig';

// Função para obter a URL da foto do jogador
const getPlayerPhotoUrl = (photoFileName) => {
  if (!photoFileName) {
    return '/default-player-photo.png';
  }
  if (photoFileName.startsWith('http://') || photoFileName.startsWith('https://')) {
    return photoFileName;
  }
  const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api$/, '');
  return `${baseUrl}/uploads/${photoFileName}`;
};

// 🔥 CORREÇÃO: Aceitar parâmetros de paginação
const logicGetAllPlayers = (params = {}) => {
  // params pode conter: page, limit, name, etc
  return api.get('/players', { params });
};

const logicGetPlayerById = (id) => api.get(`/players/${id}`);

const playerService = {
  // Buscar todos os jogadores COM PARÂMETROS
  getAll: logicGetAllPlayers,          // Agora aceita { page, limit, name }
  getAllPlayers: logicGetAllPlayers,   // Também aceita parâmetros

  // Buscar um jogador específico por ID
  getById: logicGetPlayerById,
  getPlayerById: logicGetPlayerById,

  // Buscar jogador por CPF
  getPlayerByCpf: async (cpf) => {
    try {
      const cleanCpf = cpf.replace(/\D/g, '');
      const response = await api.get(`/players/cpf/${cleanCpf}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar jogador por CPF ${cpf}:`, error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  // Criar novo jogador
  createPlayer: (data) => api.post('/players', data),

  // Atualizar jogador existente
  updatePlayer: (id, data) => api.put(`/players/${id}`, data),

  // Excluir jogador
  deletePlayer: (id) => api.delete(`/players/${id}`),

  // Obter a URL da foto
  getPlayerPhotoUrl
};

export default playerService;